<my-alert rounded="false" type="primary" i18n *ngIf="hasVideoScheduledPublication()">
  This video will be published on {{ video().scheduledUpdate.updateAt | ptDate: 'full' }}.
</my-alert>

<my-alert rounded="false" type="primary" *ngIf="isWaitingForLive()">
  <ng-container i18n>This live is not currently streaming.</ng-container>

  @if (scheduledLiveDate()) {
    <ng-container i18n>
      It will start on {{ scheduledLiveDate() | ptDate: 'short' }}.
    </ng-container>
  }
</my-alert>

<my-alert rounded="false" type="primary" i18n *ngIf="isLiveEnded()">
  This live has ended.
</my-alert>

<my-alert rounded="false" type="warning" *ngIf="getAlertWarning()?.title">
  <div class="alert-title">{{ getAlertWarning()?.title }}</div>

  @if (canSeeMoreInfo()) {
    {{ getAlertWarning().watchSecondary }}
  }

  {{ getAlertWarning().watchMain }}
</my-alert>

<my-alert rounded="false" i18n type="warning" *ngIf="noPlaylistVideoFound()">
  There are no videos available in this playlist.
</my-alert>

<my-alert rounded="false" type="danger" *ngIf="video()?.blacklisted">
  <div class="blocked-label" i18n>This video is blocked.</div>

  {{ video().blacklistedReason }}
</my-alert>

<my-alert rounded="false" i18n type="warning" *ngIf="video()?.canBypassPassword(user())">
  This video is password protected.
</my-alert>
